import { h, Fragment, Component } from "preact";

// Note: Keep in sync with skeleton-loader.liquid and its associated snippets

class SkeletonFacet extends Component {
  render() {
    return (
      <div class="ss__facet ss__facet--collapsed display-icons skeleton-facet">
        <div class="ss__dropdown ss__facet__dropdown">
          <div class="ss__dropdown__button" role="button" aria-expanded="true">
            <div
              class="ss__facet__header"
              role="heading"
              tabindex="0"
            >
              <div class="ss__facet___header--label skeleton-facet-label skeleton-animation"></div>
              <span class="filter-tooltip skeleton-filter-tooltip"></span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

class SkeletonFacetSeparator extends Component {
  render() {
    return (
      <hr class="facet__sidebar-separator skeleton-facet__sidebar-separator" />
    )
  }
}

class SkeletonItem extends Component {
  render() {
    return (
      <article class="ss__result ss__result__hover ss__result--grid ss__results__result skeleton-item">
        <a
          href="#"
          class="ss__result-link"
        >
          <div class="product-card-top-wrapper">
            <div class="ss__result__image-wrapper">
              <div class="ss__image ss__result__image">
                <div class="skeleton-item-img">
                  <div class="skeleton-img-placeholder"></div>
                </div>
              </div>
            </div>
            <div class="ss__result__details skeleton-item-details">
              <div class="ss__result__details__top_row body-large skeleton-ss__result__details__top_row">
                <div class="ss__result__details__review skeleton-item-review skeleton-animation"></div>
                <div class="ss__result__details__pricing body-medium">
                  <span class="ss__price ss__result__price skeleton-item-price skeleton-animation"></span>
                </div>
              </div>
              <div class="ss__result__details__title body-medium skeleton-item-title skeleton-animation"></div>
              <div class="attributes-layout skeleton-attributes-layout">
                <div class="attribute-item skeleton-attribute-item">
                  <span class="eyebrow eyebrow--small skeleton-eyebrow skeleton-animation"></span>
                  <span class="body-small skeleton-body-small skeleton-animation"></span>
                </div>
                <div class="attribute-item skeleton-attribute-item">
                  <span class="eyebrow eyebrow--small skeleton-eyebrow skeleton-animation"></span>
                  <span class="body-small skeleton-body-small skeleton-animation"></span>
                </div>
                <div class="attribute-item skeleton-attribute-item">
                  <span class="eyebrow eyebrow--small skeleton-eyebrow skeleton-animation"></span>
                  <span class="body-small skeleton-body-small skeleton-animation"></span>
                </div>
              </div>
            </div>
          </div>
        </a>
      </article>
    )
  }
}

export class SkeletonLoader extends Component {
  render() {
    return (
      <div class="skeleton-loader" aria-hidden="true">
        <header class="ss-header-container ss-header-results-found">
          <h2 class="ss-title ss-results-title headline headline-medium"></h2>
        </header>
        <div class="ss-results-left-column left-column-wrapper skeleton-ss-results-left-column">
          <div class="clear"></div>
          <div class="ss-sidebar-container-left-column skeleton-ss-sidebar-container-left-column">
            <div class="ss-sidebar-heading skeleton-sidebar-heading">
              <h1 class="headline headline-small ss-sidebar-heading__collection skeleton-headline skeleton-animation"></h1>
              <div class="body-small skeleton-animation"></div>
              <a href="#" class="button button--link-1 skeleton-animation" target="_blank"></a>
            </div>
            <div class="ss__facets">
              <div
                id="ss__facet--collection_name"
                class="ss__facet ss__facet--collection_name ss__facet--collapsed skeleton-facet"
              >
                <div class="ss__dropdown ss__facet__dropdown">
                  <div class="ss__dropdown__button" role="button" aria-expanded="true">
                    <div class="ss__facet__header">
                      <div class="ss__facet___header--label skeleton-facet-label skeleton-animation"></div>
                    </div>
                  </div>
                  <div class="ss__dropdown__content">
                    <div class="ss__custom-facet ss__facet__options">
                      <div class="ss__facet-list-options"></div>
                    </div>
                  </div>
                </div>
              </div>

              {Array(9).fill(true).map((_, index) => {
                return (
                  <>
                    <SkeletonFacetSeparator key={`separator-${index}`} />
                    <SkeletonFacet key={`facet-${index}`} />
                  </>
                )
              })}

              <SkeletonFacetSeparator />
            </div>
          </div>

          <div class="ss-results__main-wrapper skeleton-ss-results__main-wrapper">
            <div class="ss-results__top-wrapper skeleton-ss-results__top-wrapper">
              <span class="left-hand">
                <div class="product-count skeleton-product-count skeleton-animation"></div>
                <div class="desktop-filter-summary"><span class="active-filters"></span></div>
              </span>
              <div class="ss-toolbar ss-toolbar-top sticky skeleton-toolbar skeleton-animation" id="toolbar-filters"></div>

              <div class="ss-sidebar-heading skeleton-mobile-only">
                <h1 class="headline headline-small ss-sidebar-heading__collection skeleton-headline skeleton-animation"></h1>
                <div class="body-small skeleton-body-small skeleton-animation"></div>
                <a href="#" class="button button--link-1 skeleton-button--link-1 skeleton-animation"></a>
              </div>
              <div class="ss-toolbar ss-toolbar-top sticky skeleton-mobile-only" id="toolbar-filters-mobile">
                <div class="toolbar-wrapper left-column-sticky">
                  <div class="ss__select ss-sort-by skeleton-select-placeholder skeleton-animation"></div>
                  <div class="ss__slideout__button skeleton-select-placeholder skeleton-animation"></div>
                </div>
              </div>
            </div>
            <div class="ss__results skeleton-items">
              {Array(6).fill(true).map((_, index) => <SkeletonItem key={index} />)}
            </div>
            <div class="center load-more-button ss-toolbar-col page-width skeleton-load-more">
              <div class="text-center">
                <p class="ss__results__current-viewing"></p>
                <button class="button button--secondary-black skeleton-load-more-btn"></button>
              </div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    )
  }
}
